import Hero from "../components/Hero.jsx";
import FeaturedMenu from "../components/FeaturedMenu.jsx";
import TastyStorySection from "../components/TastyStorySection.jsx";
import Testimonials from "../components/Testimonials.jsx";
import WorkingHours from "../components/WorkingHours.jsx";
export default function Home() {
    return (
        <div>
            <Hero />
            <TastyStorySection />
            <FeaturedMenu />
            <WorkingHours />
            <Testimonials />
        </div>
    );
}
